/**
 * @param {string} path
 * @returns {Promise<Blob>}
 */
export async function fetchAuthorizedBlob(path) {
  const { getToken, formatApiError } = await import('./client.js');
  const headers = { Accept: '*/*' };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;

  const res = await fetch(path, { headers });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(formatApiError(data, res.status));
  }
  return res.blob();
}

/**
 * @param {number} id
 * @param {FormData} form
 */
export async function uploadPdfCompiled(id, form) {
  const { getToken, formatApiError } = await import('./client.js');
  const headers = { Accept: 'application/json' };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;

  const res = await fetch(`/api/admin/pdf-documents/${id}/compiled`, {
    method: 'POST',
    headers,
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatApiError(data, res.status));
  return data;
}
